import { ApplicationState } from 'application/redux'
import { connect } from 'react-redux'
import RtfComponent from './RtfComponent'
import { clearCurrentDevice, getDevice } from './redux/devices/actions'
import { clearHistory } from './redux/logs/history/actions'
import { getAssetsValuesAndSetSettings } from './redux/settings/actions'

const mapStateToProps = (state: ApplicationState) => ({
  currentDevice: state.rtf.rtfDevices.current,
  t: state.i18n.t,
  settings: state.rtf.rtfSettings,
})

export default connect(mapStateToProps, {
  getDevice,
  clearCurrentDevice,
  getAssetsValuesAndSetSettings,
  clearHistory,
})(RtfComponent)
